import { useRef, useState } from "react";
import Draggable from "react-draggable";

export default function DragTract({ drop, tractNumber, ...rest }) {
    const nodeRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const handleDrag = () => {
        setIsDragging(true);
    };
    const handleStop = (e, d) => {
        setIsDragging(false);
        drop(e, d);
    };
    return (
        <Draggable
            handle={`.tract${tractNumber}`}
            scale={1}
            onStop={handleStop}
            onDrag={handleDrag}
            nodeRef={nodeRef}
            {...rest}
        >
            <div
                className={`tract${tractNumber} border-2 border-black rounded-full cursor-move text-center w-10 h-7 mr-2 mb-2 ${
                    isDragging ? "opacity-5" : ""
                }`}
                ref={nodeRef}
            >
                <div className="font-bold px-2 rounded-full bg-white">
                    {tractNumber}
                </div>
            </div>
        </Draggable>
    );
}
